import CurrencyBox from "./CurrencyBox";
import currencyPairs from "../json/CurrencyPairs.json";
import RoundFlag from "../utils/CountryFlagsRound";
import { priceStore } from "../zustand/priceStore";
import { Objects } from "../models/CurrencyPair";

function CurrencyList(): JSX.Element {
	const values = priceStore((state) => state.prices);
	let currencyPair: Objects = currencyPairs;
	return (
		<div className="currency-box">
			{values &&
				values.map((value, index) => {
					if (
						currencyPair[value.ccyPair] !== undefined &&
						currencyPair[value.ccyPair] !== null
					) {
						const roundFlag = RoundFlag(currencyPair[value.ccyPair].ccy1);
						return (
							<CurrencyBox flag={roundFlag} pair={value.ccyPair} price={value.midRate} />
						);
					} else {
						// in-case new ccy pair not mapped properly show empty box
						return (
							<CurrencyBox flag={null} pair={value.ccyPair} price={"0.0"} />
						);
					}
				})}
		</div>
	);
}

export default CurrencyList;
